import React, { ReactElement, useState } from "react";
import {
    CartAddressContext,
    CartAddressState,
    INITIAL_CART_ADDRESS_CONTEXT_VALUE,
} from "@cart-client/contexts/CartAddressContext";

export function CartAddressContextProvider(props: { children: React.ReactNode }): ReactElement {
    const [cartAddressState, setCartAddressState] = useState<CartAddressState>(
        INITIAL_CART_ADDRESS_CONTEXT_VALUE.cartAddressState,
    );

    const cartAddressContextValue = React.useMemo(
        () => ({
            cartAddressState,
            setCartAddressState,
        }),
        [cartAddressState],
    );
    return <CartAddressContext.Provider value={cartAddressContextValue}>{props.children}</CartAddressContext.Provider>;
}
